<template>
  <div class="economic-dynamics">
    <div class="section-title">
      <!-- <span class="title-icon">📈</span> -->
      <span class="title-text">企业经济动态(2022~2025)</span>
    </div>

    <div class="chart-container">
      <Echart
          :options="chartOptions"
          id="EconomicDynamicsChart"
          height="100%"
          width="100%"
      ></Echart>
    </div>
  </div>
</template>

<script>
import {get} from "@/utils/request";
export default {
  name: 'EconomicDynamics',
  data() {
    return {
      VUE_APP_API_BASE_URL:"https://dp.houkongfan.cn",
      qyjjdtList: [],
      chartData: {
        years: [],
        taxRevenue: [], // 入库税金
        invoicedSales: [], // 开票销售
        totalOutput: [], // 总产值
      },
    }
  },
  mounted() {
    this.onLoadInfo()
  },
  methods: {
    async onLoadInfo() {
      const url =this.VUE_APP_API_BASE_URL + "/dev-api/system/page1/queryList/model4"
      const result = await get(url)
      // 查询产业类型列表
      this.qyjjdtList = result.data.qyjjdtList
      if (result.success) {
        if (!this.qyjjdtList || this.qyjjdtList.length === 0) return;

        const qyjjdtList = this.qyjjdtList;

        // 提取唯一年份并排序
        const uniqueYears = [...new Set(qyjjdtList.map(item => item.year))].sort();
        this.chartData.years = uniqueYears.map(year => {
          // 统一处理年份格式
          return year.includes('年') ? year : `${year}年`;
        });

        // 根据年份提取对应数据，使用 money 字段
        this.chartData.taxRevenue = uniqueYears.map(year => {
          const item = qyjjdtList.find(d => d.year === year && d.legendType === '入库税金');
          return item ? parseFloat(item.money) : 0;
        });

        this.chartData.invoicedSales = uniqueYears.map(year => {
          const item = qyjjdtList.find(d => d.year === year && d.legendType === '开票销售');
          return item ? parseFloat(item.money) : 0;
        });

        this.chartData.totalOutput = uniqueYears.map(year => {
          const item = qyjjdtList.find(d => d.year === year && d.legendType === '总产值');
          return item ? parseFloat(item.money) : 0;
        });
      }
    }
  },
  computed: {
    chartOptions() {
      return {
        backgroundColor: 'transparent',
        grid: {
          left: '10%',
          right: '8%',
          top: '15%',
          bottom: '10%',
        },
        tooltip: {
          trigger: 'item',
          backgroundColor: 'rgba(0, 0, 0, 0.8)',
          borderColor: '#00d9ff',
          borderWidth: 1,
          textStyle: {
            color: '#fff',
          },
          formatter: (params) => {
            return `${params.seriesName}<br/>${params.name}: ${params.value}`
          },
        },
        legend: {
          data: ['入库税金', '开票销售', '总产值'],
          top: '5%',
          textStyle: {
            color: '#fff',
            fontSize: 14,
          },
          itemGap: 30,
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: this.chartData.years,
          axisLine: {
            show: true,
            lineStyle: {
              color: 'rgba(0, 217, 255, 0.3)',
            },
          },
          axisTick: {
            show: false,
          },
          axisLabel: {
            color: '#fff',
            fontSize: 14,
          },
        },
        yAxis: {
          type: 'value',
          name: '金额 (亿元)',
          nameTextStyle: {
            color: '#6b7d8f',
            fontSize: 12,
          },
          min: 0,
          max: 220,
          axisLine: {
            show: false,
          },
          axisTick: {
            show: false,
          },
          axisLabel: {
            color: '#fff',
            fontSize: 12,
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: 'rgba(0, 217, 255, 0.1)',
              type: 'dashed',
            },
          },
        },
        series: [
          {
            name: '入库税金',
            type: 'line',
            data: this.chartData.taxRevenue,
            smooth: true,
            symbol: 'circle',
            symbolSize: 12,
            z: 1,
            lineStyle: {
              color: '#ff4757',
              width: 5,
            },
            itemStyle: {
              color: '#ff4757',
            },
            areaStyle: {
              color: {
                type: 'linear',
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  {
                    offset: 0,
                    color: 'rgba(255, 71, 87, 0.3)',
                  },
                  {
                    offset: 1,
                    color: 'rgba(255, 71, 87, 0.05)',
                  },
                ],
              },
            },
            label: {
              show: true,
              position: 'top',
              formatter: '{c}',
              color: '#fff',
              fontSize: 12,
            },
          },
          {
            name: '开票销售',
            type: 'line',
            data: this.chartData.invoicedSales,
            smooth: true,
            symbol: 'circle',
            symbolSize: 12,
            z: 2,
            lineStyle: {
              color: '#ffc000',
              width: 5,
            },
            itemStyle: {
              color: '#ffc000',
            },
            areaStyle: {
              color: {
                type: 'linear',
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  {
                    offset: 0,
                    color: 'rgba(255, 192, 0, 0.3)',
                  },
                  {
                    offset: 1,
                    color: 'rgba(255, 192, 0, 0.05)',
                  },
                ],
              },
            },
            label: {
              show: false,
              position: 'top',
              formatter: '{c}',
              color: '#fff',
              fontSize: 12,
            },
          },
          {
            name: '总产值',
            type: 'line',
            data: this.chartData.totalOutput,
            smooth: true,
            symbol: 'circle',
            symbolSize: 12,
            z: 3,
            lineStyle: {
              color: '#00d9ff',
              width: 5,
            },
            itemStyle: {
              color: '#00d9ff',
            },
            areaStyle: {
              color: {
                type: 'linear',
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  {
                    offset: 0,
                    color: 'rgba(0, 217, 255, 0.3)',
                  },
                  {
                    offset: 1,
                    color: 'rgba(0, 217, 255, 0.05)',
                  },
                ],
              },
            },
            label: {
              show: true,
              position: 'top',
              formatter: '{c}',
              color: '#fff',
              fontSize: 12,
            },
          },
        ],
      }
    },
  },
}
</script>


<style lang="scss" scoped>
.economic-dynamics {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;

  .section-title {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-bottom: 10px;
    font-size: 18px;
    font-weight: 600;
    color: #fff;
    padding-bottom: 8px;
    border-bottom: 2px solid rgba(0, 217, 255, 0.3);

    .title-icon {
      font-size: 20px;
    }
  }

  .chart-container {
    flex: 1;
    min-height: 0;
    border-radius: 8px;
    border-radius: 8px;
    padding: 10px;
  }
}
</style>

